export default "__VITE_ASSET__4cf299e6__"